import React from "react";
import SysApiLogDetailsView from "../component/SysApiLogDetailsView";

const SysApiLogDetailContainer = ({ pageId }) => (<SysApiLogDetailsView pageId={ pageId } />)

export default SysApiLogDetailContainer;